import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function EmailSettings({
  color = 'icon.primary',
  fill = 'transparent',
  stroke,
  ...props
}) {
  return (
    <IconBase viewBox='0 0 14 12' {...props}>
      <Path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.5 2.3V2.3C0.5 2.73333 0.716667 3.09444 1.07778 3.38333L5.41111 6.34444C6.42222 6.99444
         7.65 6.99444 8.66111 6.34444L12.9944 3.45556C13.2833 3.09444 13.5 2.73333 13.5 2.3V2.3C13.5
          1.57778 12.9222 1 12.2 1L1.8 1C1.07778 1 0.5 1.57778 0.5 2.3Z'
        stroke={color}
        fill={fill}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M0.5 2.44531L0.5 9.66753C0.5 10.462 1.15 11.112 1.94444 11.112L12.0556
         11.112C12.85 11.112 13.5 10.462 13.5 9.66753L13.5 2.44531'
        stroke={color}
        fill='transparent'
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M0.921875 10.6903L5.3231 6.28906'
        stroke={color}
        fill={fill}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M8.70312 6.3125L13.074 10.6834'
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

EmailSettings.propTypes = {
  color: PropTypes.string,
  stroke: PropTypes.string,
  fill: PropTypes.string,
}

export default EmailSettings
